export default {
  registration_number: "Nomor Induk",
  master_student: "Master Nomor Induk Siswa",
  master_teacher: "Master Nomor Induk Guru",
  master_staff: "Master Nomor Induk Staff"
};
